import styled from 'styled-components';
import { inputVariableStyles } from '../../utils/forms/variables';
import { FormComponentProps } from '../types';

export type InputGroupProps = React.HTMLAttributes<HTMLDivElement> & FormComponentProps;

export const InputGroup = styled.div<InputGroupProps>`
  ${inputVariableStyles}

  display: flex;

  /* Remove inline margins from all children */
  & > * {
    margin-left: 0;
    margin-right: 0;
    box-shadow: none;
  }

  /* Bring in-focus and active children to the front to maintain outlines */
  & > *:focus,
  & > *:active {
    z-index: 5;
  }

  /* Remove inline borders for children in the middle */
  & > *:not(:first-child):not(:last-child) {
    border-radius: 0 !important;
    border-inline: 0 !important;
  }

  /* Remove right border radius from first child */
  & > *:first-child {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    border-right: 0 !important;
  }

  /* Remove left border radius from last child */
  & > *:last-child {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    border-left: 0 !important;
  }
`;
